import React from 'react'

export default () => (
  <p>Hallo world</p>
) 


// WEBPACK FOOTER //
// ./sampleProject/src/Features/OnBoarding/Introduction/index.tsx